import React from 'react';
import './UserLimitBanner.scss';

const UserLimitBanner = ({ userCount, userLimit, isVisible }) => {
  if (!isVisible) return null;

  const percentage = Math.round((userCount / userLimit) * 100);
  const remaining = userLimit - userCount;

  return (
    <div className="user-limit-banner">
      <div className="user-limit-content">
        <div className="user-limit-info">
          <span className="user-limit-count">{userCount.toLocaleString()}</span>
          <span className="user-limit-separator">/</span>
          <span className="user-limit-total">{userLimit.toLocaleString()}</span>
          <span className="user-limit-label">spots claimed</span>
        </div>
        <div className="user-limit-progress">
          <div 
            className="user-limit-progress-bar" 
            style={{ width: `${Math.min(percentage, 100)}%` }}
          />
        </div>
        <div className="user-limit-remaining">
          {remaining > 0 ? (
            <span className="remaining-text">
              Only <strong>{remaining.toLocaleString()}</strong> spots left!
            </span>
          ) : (
            <span className="full-text">
              <strong>All spots claimed!</strong>
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default UserLimitBanner;
